import { BCLabel, findMessage, ILabelProps } from '@bimser/components';
import { FormItemTypes, HorizontalAlign, IDictionary } from '@bimser/core';
import { JSX } from 'react';
import { CovertFontToCSS, ICSSProperties, IPropertyField } from '../../../../entities/common';
import LabelBase from '../../base/LabelBase';
import { ILabelProperties } from './entities/ILabelProperties';

export default class Label extends LabelBase {
	textAlign: HorizontalAlign;

	constructor() {
		super();

		this.controlType = FormItemTypes.EControlTypes.Label;

		this.font = {
			bold: true,
			color: '#4a90e2',
			family: 'Source Sans Pro, sans-serif',
			italic: false,
			size: '12',
			strikethrough: false,
			underline: false
		};

		this.textAlign = 'left';
	}

	initialize() {
		super.initialize();
		this.text.setData({ [this.__form.currentLanguage.culture]: findMessage.get('100554') });
	}

	__loadProperties(data: ILabelProperties) {
		super.__loadProperties(data);

		this.__proxyChanged.textAlign = data.textAlign;
	}
	__getComponentData(): ILabelProps & IDictionary<any> {
		return {
			...super.__getComponentData(),
			textAlign: this.textAlign
		};
	}

	__getPropertyFields(): IPropertyField[] {
		return [
			...super.__getPropertyFields(),
			{
				name: 'textAlign',
				type: 'enum',
				enumMembers: ['left', 'center', 'right']
			}
		];
	}

	private getStyles(): ICSSProperties {
		return CovertFontToCSS(this.font);
	}

	__render(children?: JSX.Element) {
		const style: React.CSSProperties = {
			...this.getStyles(),
			...this.style,
			height: this.height,
			lineHeight: this.lineHeight
		};

		return super.__render(
			<BCLabel
				customStyles={style}
				title={this.title.getText()}
				align={this.textAlign}
			>
				{this.text.getText()}
			</BCLabel>
		);
	}
}
